import React from 'react';

import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { Modal } from '@wds/modal';

import PropTypes from 'prop-types';
import staffImg from '../../../sma.marketplace/staff/components/tools/extras';
import getComponentWithTheme from '../../../themeProvider';

const StaffImageModal = ({ open, setOpen }) => (
	getComponentWithTheme(
		<Modal
			show={open}
			onClose={() => setOpen(false)}
			id='sma-superuser-image-modal'
			size='md'
			width={650}
			padding={10}
		>
			<Modal.Body>
				<Box>
					<Box display='flex' justifyContent='center'>
						<img src={staffImg} alt='Apply' width={610} />
					</Box>
					<Box display='flex' justifyContent='center' mt={5}>
						<Typography>
							❤️
						</Typography>
					</Box>
				</Box>
			</Modal.Body>
		</Modal>,
	)
);

StaffImageModal.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
};
export default StaffImageModal;
